import { useRouter } from 'next/router'
import { FacebookLoader } from 'cc/Loader'
import OpenGraph from 'components/OpenGraph'
import hoistNonReactStatic from 'hoist-non-react-statics'

const FallbackPage = ({ title, Loader }) => (
  <>
    <Loader />
    <OpenGraph title={title} />
  </>
)

export const handleFallback = (
  Component,
  { Loader = FacebookLoader, loadingTitle = 'Loading...' },
) => {
  const WrappedComponent = (props) => {
    const router = useRouter()
    if (router.isFallback)
      return <FallbackPage title={loadingTitle} Loader={<Loader />} />
    return <Component {...props} />
  }
  hoistNonReactStatic(WrappedComponent, Component)
  return WrappedComponent
}
